import axios from 'axios'

export const cscClient = axios.create({
  baseURL: process.env.REACT_APP_CSC_API_URL,
  timeout: 15000,
})

function cscHeaders() {
  return {
    'X-CSCAPI-KEY': process.env.REACT_APP_CSC_API_KEY,
    Accept: 'application/json',
  }
}

export async function getCountries() {
  const { data } = await cscClient.get('/countries', { headers: cscHeaders() })
  return data
}

export async function getStates(countryIso2) {
  if (!countryIso2) return []
  const { data } = await cscClient.get(`/countries/${countryIso2}/states`, {
    headers: cscHeaders(),
  })
  return data
}

export async function getCities(countryIso2, stateIso2) {
  if (!countryIso2 || !stateIso2) return []
  const { data } = await cscClient.get(`/countries/${countryIso2}/states/${stateIso2}/cities`, {
    headers: cscHeaders(),
  })
  return data
}
